// @flow

import React, { Component } from "react";
import classNames from "classnames";

import PostWidgetChatBubble from "./post-widget-chat-bubble";
import PostWidgetInfoSection from "./post-widget-info-section";
import Checkbox from "../../checkbox";
import type { CheckboxWidget as CheckboxWidgetProps } from "react-jsonschema-form/lib/components/widgets/CheckboxWidget";

type Props = $Exact<{
  ...CheckboxWidgetProps,
  options: Object,
}>;

type State = $Exact<{
  checked: boolean | string,
}>;

export class CheckboxWidget extends Component<Props, State> {
  state = {
    checked: !!this.props.options.emptyValue,
  };

  handleChange = (event: SyntheticEvent<HTMLInputElement>) => {
    const checked =
      this.props.schema.type === "boolean"
        ? event.currentTarget.checked
        : event.currentTarget.value;

    this.setState({ checked });
    return this.props.onChange(checked);
  };

  render() {
    const props = Object.assign({}, this.props, {
      readOnly: this.props.readonly,
      autoFocus: this.props.autofocus,
      onChange: this.handleChange,
      checked: this.state.checked,
    });

    delete props.readonly;
    delete props.formContext;
    delete props.autofocus;
    delete props.rawErrors;
    delete props.registry;
    delete props.schema;

    return (
      <React.Fragment>
        <Checkbox
          {...props}
          label={props.options.labelposition !== "left" ? props.label : ""}
          checked={props.value}
          className={classNames("mt-1", props.className)}
        />
        <PostWidgetChatBubble options={this.props.options} />
        <PostWidgetInfoSection options={this.props.options} />
      </React.Fragment>
    );
  }
}

export default CheckboxWidget;
